import cx from "clsx";
import type { JSX } from "react";

import FormError from "#guidelines/Form/Error";
import { Fieldset } from "#guidelines/Form/Fieldset";

export default function FormErrors({
  errors,
  className,
}: Pick<JSX.IntrinsicElements["div"], "className"> & {
  errors: Array<string> | undefined;
}) {
  if (errors === undefined || errors?.length === 0) {
    return undefined;
  }

  return (
    <Fieldset>
      <div className={cx("flex flex-col text-center", className)}>
        {errors.map((oneError) => (
          <FormError key={oneError}>{oneError}</FormError>
        ))}
      </div>
    </Fieldset>
  );
}
